const USER_TOKEN_PARAM = "user_token";

let userToken = "";

// Remove values persisted by earlier versions; the token now lives in memory only.
try {
  localStorage.removeItem("user_token");
} catch (_) {
  // Storage can be unavailable in hardened browser contexts.
}

export function setUserToken(token) {
  userToken = typeof token === "string" ? token.trim() : "";
}

export function getUserToken() {
  return userToken;
}

export function syncUserTokenFromSearch(search = window.location.search) {
  const searchParams = new URLSearchParams(search);

  // Keep the in-memory token when navigating to a route without the query
  // parameter. An explicitly empty parameter clears it.
  if (searchParams.has(USER_TOKEN_PARAM)) {
    setUserToken(searchParams.get(USER_TOKEN_PARAM));
  }

  return userToken;
}

// Initialize synchronously so requests fired by the first render can use it.
syncUserTokenFromSearch();
